import { translate } from '@/domains/core/localization/translate';
export const {
  quantity,
  soldBy,
  deliveredByMm
} = translate({
  "quantity": "Quantity:",
  "soldBy": "Sold by",
  "deliveredByMm": "Delivered by ManoMano"
});